import React from "react";

interface IErrorMessageProps {
  message?: string;
  className?: string;
}

const ErrorMessage: React.FC<IErrorMessageProps> = ({
  message,
  className = "",
}) => {
  if (!message) return null;

  return <p className={`text-xs text-danger mt-1 ${className}`}>{message}</p>;
};

export default ErrorMessage;
